module.exports = __webpack_public_path__ + "img/carousel1.5c94dc24.jpg";